import { useState, useEffect } from "react";
import { CircleFadingArrowUp } from "lucide-react";

const CIRCLE_RADIUS = 26;
const CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;
const SHOW_THRESHOLD_PX = 100;

const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      setScrollProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
      setShowButton(scrollTop > SHOW_THRESHOLD_PX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const offset = CIRCUMFERENCE - (scrollProgress / 100) * CIRCUMFERENCE;

  if (!showButton) return null;

  return (
    <div
      onClick={scrollUp}
      className="fixed bottom-5 right-5 w-14 h-14 cursor-pointer group"
    >
      <svg className="absolute top-0 left-0 w-full h-full -rotate-90">
        <circle cx="28" cy="28" r={CIRCLE_RADIUS} stroke="#e5e7eb" strokeWidth="4" fill="none" />
        <circle
          cx="28"
          cy="28"
          r={CIRCLE_RADIUS}
          stroke="url(#scroll-gradient)"
          strokeWidth="4"
          fill="none"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={offset}
          strokeLinecap="round"
          className="transition-all duration-200"
        />
        <defs>
          <linearGradient id="scroll-gradient">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>
      </svg>

      <div className="w-14 h-14 bg-slate-800 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition">
        <CircleFadingArrowUp className="w-6 h-6 text-white" />
      </div>
    </div>
  );
};

export default ScrollToTop;
